import { useAuth } from './useAuth';

// THIS SHOULD BE REFACTORED INTO useAuth BUT I DONT WANT TO TOUCH THAT RIGHT NOW
export const useRole = () => {
  const { role, isAuthenticated } = useAuth();

  const isAdmin = isAuthenticated && role === 'ADMIN';

  return {
    role,
    isAdmin,
  };
};
